// extracted by mini-css-extract-plugin
export default {"mdBreak":"1024px","backofficeUsers":"HIEb4mtOmoX6FWiRkwJ3"};